export default __webpack_public_path__ + "images/0c6c36bc77e753bb5a0753eb1356fa76.png";